import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/common/contexts/AuthContext';

const useContent = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const emailsList = useMemo(
    () => [
      ...user.customer.contact_emails.map((item) => ({
        key: item.email,
        value: item.email,
      })),
      {
        key: user.email, // Ajoutez l'e-mail de l'utilisateur ici
        value: user.email,
      },
      {
        key: t('ebat:entities:scanbat.checkout.confirmation.email.new'),
        value: '0',
      },
    ],
    [t, user],
  );

  return {
    emailsList,
  };
};

export default useContent;
